import { jsx as z } from "react/jsx-runtime";
import d from "../../../ui-kit/theme-button.mjs";
import { useStore as R } from "../../../store/index.mjs";
import { BadRequest as b } from "@systemeio/util";
import { razorpayBuyOffer as h } from "../api/razorpay-api.mjs";
import w from "../hooks/useRazorpay.mjs";
function k({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: a,
  setIsFetching: o,
  handleBadRequest: n,
  preSubmit: i
}) {
  const { locale: s } = R(), { generateOptions: p, isRazorpayReady: m, Razorpay: f, isRazorpayFetching: y } = w();
  return /* @__PURE__ */ z(
    d,
    {
      disabled: a,
      type: "submit",
      onClick: async (c) => {
        c.preventDefault(), o(!0);
        try {
          const r = i();
          if (!r) return;
          const u = await h(r, s), l = p(u);
          if (m)
            new f(l).open();
          else
            throw new Error("form submitted before razorpay was ready");
        } catch (r) {
          if (r instanceof b)
            n(r);
          else
            throw r;
        } finally {
          o(!1);
        }
      },
      isFetching: t || y,
      children: e
    }
  );
}
export {
  k as RazorpayPaymentButton
};
